export default {
  namespaced: true,
  state: {
    currentPopup: null
  },
  mutations: {
    setCurrentPopup(state, popupName) {
      state.currentPopup = popupName
    }
  },
  actions: {
    setCurrentPopup({ commit }, popupName) {
      commit('setCurrentPopup', popupName)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/popup.js